// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable import/no-restricted-paths, react/state-in-constructor, react/destructuring-assignment, react/jsx-handler-names */
import React, { Component } from "react"
import * as R from "ramda"
import * as cookies from "@kiwicom/cookies"
import NewSelectField from "@kiwicom/frontend-common/components/NewSelectField/NewSelectField"

import brandMetadata from "../../../../data/brandMetadata.json"

const DEFAULT_OPTION = { value: "", label: "Autodetect brand (default)" }

const parsedBrandMetadata = brandMetadata.brands.sort().map((x) => ({ value: x, label: x }))
const parsedBrandMetadataWithDefault = R.prepend(DEFAULT_OPTION, parsedBrandMetadata)

class SetBrand extends Component {
  constructor(props) {
    super(props)
    this.state = {
      brandingId: cookies.load("forced_brand"),
    }
  }

  setBrand = (brandingId) => {
    this.setState({ brandingId })
    cookies.save("forced_brand", brandingId)
    document.location.reload()
  }

  render() {
    return (
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line react/jsx-filename-extension
      <NewSelectField
        label="Brand"
        value={this.state.brandingId}
        options={parsedBrandMetadataWithDefault}
        onChange={this.setBrand}
      />
    )
  }
}

export default SetBrand
